export default "__VITE_ASSET__$dRzx9NV__"